// F8 / FR-RD15: main-window banner offered when the desktop shell sees a Zoom or Teams
// meeting window. Mounted once in App.tsx like TraySync. Never auto-starts: "Record this
// meeting" only navigates to the recorder, where ConsentAnnouncement gates the start.
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Callout } from "@grackle/ui";
import { orgSlugFromPath, resolveActiveOrg } from "../lib/lastOrg";
import { useSession } from "../session";
import { detectedBannerText } from "../recorder/meetingCapture";
import { useMeetingDetector } from "../recorder/useMeetingDetector";
import "../recorder/recorder.css";

export default function MeetingDetectedBanner() {
  const { user, orgs } = useSession();
  const location = useLocation();
  const navigate = useNavigate();
  const onRecorder = location.pathname.startsWith("/record") || location.pathname === "/hud";
  const { candidate, dismiss } = useMeetingDetector(Boolean(user) && !onRecorder);
  if (!user || onRecorder || !candidate) return null;
  const org = resolveActiveOrg(orgs, orgSlugFromPath(location.pathname));

  function record() {
    if (!candidate) return;
    const qs = new URLSearchParams({ meeting: candidate.source_id, platform: candidate.capture_platform, app: candidate.app, title: candidate.title });
    if (org) qs.set("org", org.slug);
    dismiss();
    navigate(`/record?${qs.toString()}`);
  }

  return (
    <div className="meeting-banner">
      <Callout tone="record" icon="info" aria-label="Meeting detected">
        <span className="meeting-banner__row">
          <span>{detectedBannerText(candidate.app)}</span>
          <span className="meeting-banner__actions">
            <Button size="sm" variant="record" onClick={record}>
              Record this meeting
            </Button>
            <Button size="sm" variant="secondary" onClick={dismiss}>
              Not now
            </Button>
          </span>
        </span>
      </Callout>
    </div>
  );
}
